import React, { useCallback, useContext, useEffect, useState } from 'react';
import Select from "react-select";
import PageTitle from '../../Components/PageTitle';
import copy from 'clipboard-copy';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import Swal from 'sweetalert2';
import { currentDateAndTime} from '../../Constants/Constants';
import { IconButton, SubmitButton } from '../../Components/InputElements';
import { NoRecords } from '../../Components/Shimmer'; 


const BiometricRegistration = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const [rows, setRows] = useState([]);
    const [filterData, setFilterData] = useState({ company_id: "", location_id: "", });
    const [formData, setFormData] = useState({
        company_id: "",
        location_id: "",
        biometric_machine_code: "",
        biometric_machine_serial_no: "",
        key_code: "",
    });
    const [modal, setModal] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [errors, setErrors] = useState({});
    const [loadingPost, setLoadingPost] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [formLocationOptions, setFormLocationOptions] = useState([]);
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false
    });


const getCompanies = () => {
    const headers = apiHeaderJson;
    // console.log("headers =>",headers);
    axios.get(`${apiURL}CompanyMasters/getCompanies`, {
        params: {
        }, headers
    }).then((response) => {
        let data = response.data;
        // console.log(data);
        if (response.data.success === true) {
            let rows = data?.companies?.map((val,idx) => {
                return  { value: val?.company_id, label: val?.company_name }
            });
            setCompanyOptions(rows);
            
        } else {
            console.error("Error fetching list");
        }
    }).catch((error) => {
        console.error("error", error);
    });
}

const getMasterList = useCallback(() => {
    const headers = apiHeaderJson;
    axios.get(`${apiURL}ReportRouter/EmploymentMasterList`,
        {
            params: {
                company_id: modal ? formData?.company_id : filterData?.company_id,
                locations:true,
                departments: false,
                date: currentDateAndTime(),
            }
            , headers
        }).then(async (response) => {
            var data = response.data;
            console.log("getMasterList => EmploymentMasterList", data);
            if (data?.success === true) {
                const locations = data?.data?.location_list?.map((val) => {
                    return { value: val?.location_id, label: val?.location_title }
                });
                if (modal) {
                    setFormLocationOptions(locations)
                }
                else{
                    setLocationOptions(locations);
                }
            }
            else{
                Swal.fire({
                    title: `<strong>${data?.success ? 'Success' : 'Failed'}</strong>`,
                    text: response?.data?.message,
                    icon: data?.success ? 'success' : 'error',
                    showConfirmButton: true, 
                    allowOutsideClick: false,
                })
            }
        })
        .catch((error)=>{
        Swal.fire({
            title: '<strong>Error</strong>',
            html: error.message,
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
        });
    });
},[apiHeaderJson, apiURL, formData?.company_id, filterData?.company_id, modal]);


const getList = useCallback(() => {
    const headers = apiHeaderJson;
    axios.get(`${apiURL}Companies/GetRegisteredBioMachineList`, {
        params:{
            company_id: filterData?.company_id,
            location_id: filterData?.location_id,
            limit: pagination?.limit || 10,
            page: pagination?.page || 1,
        },
        headers })
    .then((response) => {
        const { success, data } = response.data;
        if (success === true) {
            console.log(data);
            setRows(data);
            setPagination({
                next: response.data?.next,
                prev: response.data?.prev,
                page: response.data?.page,
                total_records: response.data?.total_records,
                total_pages: response.data?.total_pages,
            })
        }
        setLoadingFilter(false);
    })
    .catch((error)=>{
        setLoadingFilter(false);
        Swal.fire({
            title: '<strong>Error</strong>',
            html: error.message,
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
        });
    });
},[apiHeaderJson, apiURL, filterData?.company_id, filterData?.location_id, pagination?.limit, pagination?.page]);

const getInfo=(row)=>{
    setFormData({
        machine_id: row?.machine_id,
        company_id: row?.company_id,
        location_id: row?.location_id,
        biometric_machine_code: row?.biometric_machine_code,
        biometric_machine_serial_no: row?.biometric_machine_serial_no,
        key_code: row?.key_code,
    });
    setIsChanged("1");
    setModal(true);
}


useEffect(() => {
    getCompanies();
}, []);

useEffect(() => {
    if(isChanged === "1"){
        getMasterList();
        setIsChanged(false);
    }
    else if (isChanged === "2") {
        getList();
        setIsChanged(false);
    }
}, [getMasterList, getList, isChanged]);

const handleInputChange = (e) => {
    const {name, value} = e.target;
    
    if (name === "biometric_machine_serial_no"){
        setErrors({ ...errors, [name]: "", biometric_machine_code: "" });
    }
    else if (name === "biometric_machine_code"){
        setErrors({ ...errors, [name]: "", biometric_machine_serial_no: "" });
    }
    else{
        setErrors({ ...errors, [name]: "" });
    }

    setFormData({ ...formData, [name]: value });
}

const validateForm = () => {
    let errors = {}

    if (!formData?.company_id) {
        errors.company_id = "Company is required!"
        return errors;
    }
    if (!formData?.location_id) {
        errors.location_id = "Location is required!"
        return errors;
    }
    if ((!formData?.biometric_machine_code && !formData?.biometric_machine_serial_no)) {
        errors.biometric_machine_code = "Biometric machine code is required!"
        return errors;
    }
    if (!formData?.key_code) {
        errors.key_code = "Key code is required!"
        return errors;
    }
    if (formData?.biometric_machine_code && formData?.key_code && (formData?.biometric_machine_code === formData?.key_code)) {
        errors.key_code = "Key code cannot be same as Biometric machine code!"
        return errors;
    }
    if (formData?.biometric_machine_code && formData?.biometric_machine_serial_no && (formData?.biometric_machine_code === formData?.biometric_machine_serial_no)) {
        errors.biometric_machine_serial_no = "Serial no. cannot be same as Biometric machine code!"
        return errors;
    }
    if (formData?.key_code && formData?.biometric_machine_serial_no && (formData?.key_code === formData?.biometric_machine_serial_no)) {
        errors.biometric_machine_serial_no = "Serial no. cannot be same as key code!"
        return errors;
    }

    return errors
}


    const handleSubmit = (e) => {
        e.preventDefault();
        // return if loading is true
        if(loadingPost) return;

        setLoadingPost(true);
        const headers = apiHeaderJson;
        // validate form data and check errors
        const errors = validateForm();
        console.log("errors 1", errors);
        if (Object.keys(errors)?.length > 0) {
            setErrors(errors);
            setLoadingPost(false);
            return;
        }

        const data = {
            machine_id: formData?.machine_id || null,
            company_id: formData?.company_id,
            location_id: formData?.location_id,
            biometric_machine_code: formData?.biometric_machine_code,
            biometric_machine_serial_no: formData?.biometric_machine_serial_no,
            key_code: formData?.key_code,
            date: currentDateAndTime()
        }

        console.log("handleSubmit ~ Data =======>>>", data);
        
        axios.post(`${apiURL}Companies/RegisterBioMetricMachine`, data, {headers,})
            .then((response) => {
                const { success } = response.data;
                console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {
                    setFormData({ ...formData, machine_id: "", company_id: "", location_id: "", biometric_machine_code: "", biometric_machine_serial_no: "", key_code: "",});
                    setFormLocationOptions([]);
                    setModal(false);
                    if (filterData?.company_id && filterData?.location_id ) {
                        getList();
                    }
                }
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true, 
                    allowOutsideClick: false,
                });
                setLoadingPost(false);
            })
            .catch((error)=>{
                setLoadingPost(false);
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            });
    }
    const handleDelete = (row) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete this!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
        }).then((result) => {
            if (result.isConfirmed) {
            const headers = apiHeaderJson;
            const data = {
                company_id: filterData?.company_id,
                machine_id: row?.machine_id,
            }
            console.log("handleSubmit ~ Data =======>>>", data);        
            axios.post(`${apiURL}Companies/DeleteBioMachine`, data, {headers,})
            .then((response) => {
                const { success } = response.data;
                console.log("DeleteBioMachine ~ response =======>>>", response);
                getList();
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true, 
                    allowOutsideClick: false,
                })
                setLoadingDelete(false);
            })
            .catch((error)=>{
                setLoadingDelete(false);
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            });
        }})
    }
    const handleCopyClick = (code) => {
        copy(code);
        toast.success(`Token Has Been Copied!`, { autoClose: 1500 });
    };
    // const handleReset=()=>{
    //     setFormData({
    //         company_id: "",
    //         location_id: "",
    //         biometric_machine_code: "",
    //         key_code: "",
    //     })
    // }

    const handleCompanyFilter = useCallback((selectedOption)=>{
        console.log("selectedOption",selectedOption);
        setIsChanged("1"); 
        setFilterData({ ...filterData, company_id: selectedOption?.value, location_id:"" }); 
        setRows([]); 
        setLocationOptions([]);
    },[filterData]);

    console.log("filterData?.company_id, filterData?.location_id",filterData?.company_id, filterData?.location_id);
    console.log("formData?.company_id, formData?.location_id",formData?.company_id, formData?.location_id);

    const handleLocationFilter = useCallback((selectedOption)=>{
        setFilterData({ ...filterData, location_id: selectedOption?.value });
    },[filterData]);

    const handleCompanySelect = useCallback((selectedOption)=>{
        setIsChanged("1"); 
        setFormData({ ...formData, company_id: selectedOption?.value, location_id:"" }); 
        setLocationOptions([]);
        setErrors({ ...errors, company_id:"" });
    },[formData, errors]);
    
    const handleLocationSelect = useCallback((selectedOption)=>{
        setFormData({ ...formData, location_id: selectedOption?.value }); 
        setErrors({ ...errors, location_id:"" });
    },[formData, errors]);

    
    const handleCloseModal = () => {
        if (loadingPost) return;
        setModal(!modal);  
        setFormData({ ...formData,  company_id: "", location_id: "", biometric_machine_code: "", biometric_machine_serial_no: "", key_code: "",});
        setFormLocationOptions([]);
    }

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1");
        getList(); 
    },[getList]);

    const handleClearAll = useCallback(()=>{
        setFilterData({ company_id: "", location_id: "", });
        setRows([]); 
        setLocationOptions([]);
    },[]);

    const handlePrev = (ev) => {

        if (pagination?.prev === true) {
            setPagination({
                ...pagination,
                page: pagination?.page - 1
            });
            setIsChanged("2");
        }
    }
    const handleNext = () => {
        if (pagination?.next === true) {
            setPagination({
                ...pagination,
                page: pagination?.page + 1
            });
            setIsChanged("2");
        }
    }
    const handleChange = (e) => {
        setPagination({
            ...pagination,
            page: parseInt(e.target.value, 10)
        });
        setIsChanged("2");
    }
    const handleLimitChange = (e) => {
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value, 10),
                page: 1,
            }
        );
        setIsChanged("2");
    };

    console.log("pagination", pagination);

    return (
        <div class="main-content">
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Biometric Registration`} primary={`Home`} />
                    <div className="card">
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">
                                {"Biometric Machine Registration"}
                            </h4>
                            <SubmitButton onClick={()=>{ setModal(!modal) }}
                            buttonName={"Create"} disabled={loadingDelete}
                            type='primary' icon='ri-play-list-add-fill'/>
                        </div>
                        <div className="card-body">
                            <div className="row gy-4">
                                <div className=' col-md-4 position-relative mb-5'>
                                    <label className="form-label" >Select Company</label>
                                    <div className=' position-absolute z-2 w-100 pe-3' >
                                        <Select onChange={handleCompanyFilter} 
                                        id='company_id' name='company_id'
                                        options={companyOptions}
                                        placeholder={`Select Company`}
                                        isDisabled={loadingDelete}
                                        value={filterData?.company_id ? companyOptions.find(option => option.value === filterData?.company_id) : null}/>
                                    </div>
                                </div>
                                <div className=' col-md-4 position-relative mb-5'>
                                    <label className="form-label" >Select Location</label>
                                    <div className=' position-absolute z-2 w-100 pe-3' >
                                        <Select onChange={handleLocationFilter}
                                        id='location_id' name='location_id'
                                        options={locationOptions}
                                        placeholder={`Select Location`}
                                        isDisabled={!filterData?.company_id || loadingDelete}
                                        value={filterData?.location_id ? locationOptions.find(option => option.value === filterData?.location_id) : null}/>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-3 col-6 ">
                                    <div><label>Apply Filter</label></div>
                                    <SubmitButton otherClasses='w-100 noWrap' 
                                    onClick={handleFilter}
                                    disabled={!filterData?.company_id || !filterData?.location_id} 
                                    loading={loadingFilter==="1"} loadingMessage='Loading' 
                                    buttonName={'Filter'} icon={'ri-filter-3-fill'}  type='info' iconSide='left' />
                                </div>
                                <div className="col-lg-2 col-md-3 col-6 ">
                                    <div><label className=' text-nowrap'>Clear Filter</label></div>
                                        <SubmitButton otherClasses='w-100 noWrap' onClick={handleClearAll}
                                        disabled={!filterData?.company_id && !filterData?.location_id} 
                                        loading={loadingFilter==="2"} loadingMessage='Loading' 
                                        buttonName={'Clear'} icon={'ri-filter-3-fill'} type='secondary' iconSide='left' />
                                </div>
                            </div>
                        {/* <div className="card-body"> */}
                            <div style={{ "maxHeight": "65vh", "overflowY": "auto" }}>
                                <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative" style={{ width: "100%" }}>
                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                        <tr>
                                            <th width={"10%"} className=' text-center'>Sr.No.</th>
                                            <th>Biometric Machine Code</th>
                                            <th>Biometric Machine Serial No.</th>
                                            <th width={"10%"} className=' text-center'>Token</th>
                                            <th width={"10%"} className=' text-center'>Action</th>
                                        </tr>
                                    </thead>
                                    { rows?.length === 0 ?
                                        <tbody>
                                            <tr>
                                                <td colSpan={12}>
                                                    <NoRecords />
                                                </td>
                                            </tr>
                                        </tbody> :
                                        <tbody>
                                            { rows?.map((row, idx) => {
                                                return <tr key={row?.statutory_slab_id}>
                                                        <td className=' text-center'>{idx + 1}</td>
                                                        <td>{row?.biometric_machine_code || "--"}</td>
                                                        <td>{row?.biometric_machine_serial_no || "--"}</td>
                                                        <td className=' text-center'>
                                                            <button className=' btn btn-primary p-1' onClick={()=>{ if (row?.biomachine_token) handleCopyClick(row?.biomachine_token);}}>
                                                                Copy Token
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex justify-content-around gap-2'>
                                                                <IconButton onClick={() => {getInfo(row)}} type='primary' icon='ri-edit-line' 
                                                                disabled={loadingDelete}
                                                                tooltipName='Edit' tooltipPosition='bottom' />
                                                                <IconButton onClick={() => { handleDelete(row);}} 
                                                                loading={loadingDelete} type='danger' 
                                                                icon='ri-delete-bin-line' tooltipName='Delete' tooltipPosition='bottom' />
                                                            </div>
                                                        </td>  
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    }
                                </table>
                            </div>
                            <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                    {
                                        <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                    }
                                </div>
                                <div className='col-md-2'>
                                    <select className="form-select" disabled={ rows?.length < 10 } onChange={(e) => handleChange(e)}>
                                        {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                            <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <select className="form-select" disabled={ rows?.length < 10 } onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                        {limitOptions.map((option) => (
                                            <option key={option} value={option}>
                                                Limit {option}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                            </div>
                        {/* </div> */}
                        {modal && (
                            <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}>
                                <div className="m-auto mt-3 w-modal">
                                    <div className="modal-content">
                                        <div className="modal-header pb-0">
                                            <h5 className="modal-title" id="myModalLabel">{formData?.machine_id ? "Update" : "Create"} Biometric</h5>
                                            <button onClick={handleCloseModal} disabled={loadingPost} className="btn-close" aria-label="Close"/>
                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <form onSubmit={handleSubmit} 
                                                    className="row">
                                                        <div className={`col-md-6 ${errors.company_id ? "" : "mb-5"}`}>
                                                            <label className="form-label" >Select Company</label>
                                                            <div className=' position-absolute z-2 w-100 pe-3' >
                                                                <Select onChange={handleCompanySelect}
                                                                placeholder={`Select Company`}
                                                                options={companyOptions}
                                                                value={formData?.company_id ? companyOptions.find(option => option.value === formData?.company_id) : null}
                                                                />
                                                            </div>
                                                            {errors.company_id && <div className="text-danger mt-5">{errors.company_id}</div>}
                                                        </div>
                                                        <div className={`col-md-6 ${errors.location_id ? "" : "mb-5"}`}>
                                                            <label className="form-label" >Select Location</label>
                                                            <div className=' position-absolute z-2 w-100 pe-3' >
                                                                <Select onChange={handleLocationSelect}
                                                                options={formLocationOptions}
                                                                placeholder={`Select Location`}
                                                                isDisabled={!formData?.company_id}
                                                                value={formData?.location_id ? formLocationOptions.find(option => option.value === formData?.location_id) : null}
                                                                />
                                                            </div>
                                                            {errors.location_id && <div className="text-danger mt-5">{errors.location_id}</div>}
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <label htmlFor="biometric_machine_code" className="form-label">Biometric Machine Code</label>
                                                            <input onChange={handleInputChange}
                                                            id="biometric_machine_code" name="biometric_machine_code"
                                                            type="text" placeholder="Enter Code"
                                                            className={`form-control ${errors.biometric_machine_code ? 'is-invalid' : ''}`}
                                                            value={formData?.biometric_machine_code}
                                                            />
                                                            {errors.biometric_machine_code && <div className="text-danger">{errors.biometric_machine_code}</div>}
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <label htmlFor="key_code" className="form-label">Key Code</label>
                                                            <input onChange={handleInputChange} 
                                                                id="key_code" name="key_code"
                                                                className={`form-control ${errors.key_code ? 'is-invalid' : ''}`}
                                                                value={formData?.key_code}
                                                                type="text"
                                                                placeholder="Enter Code"
                                                            />
                                                            {errors.key_code && <div className="text-danger">{errors.key_code}</div>}
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="biometric_machine_serial_no" className="form-label">Biometric Machine Serial No.</label>
                                                            <input onChange={handleInputChange}
                                                            id="biometric_machine_serial_no" name="biometric_machine_serial_no"
                                                            type="text" placeholder="Enter no."
                                                            className={`form-control ${errors.biometric_machine_serial_no ? 'is-invalid' : ''}`}
                                                            value={formData?.biometric_machine_serial_no}
                                                            />
                                                            {errors.biometric_machine_serial_no && <div className="text-danger">{errors.biometric_machine_serial_no}</div>}
                                                        </div>
                                                        <div className="col-md-12">
                                                            <SubmitButton loading={loadingPost} loadingMessage='Loading' 
                                                            buttonName={"Save"} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BiometricRegistration;
